import type { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, Button, Container, Typography } from "@mui/material";

const NotFound: FC = () => {
    return (
        <>
            <Helmet>
                <title>Error: Not Found | Guardian</title>
            </Helmet>
            <Box
                sx={{
                    alignItems: "center",
                    backgroundColor: "background.paper",
                    display: "flex",
                    minHeight: "100%",
                    px: 3,
                    py: "80px"
                }}>
                <Container maxWidth="lg">
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            position: "relative"
                        }}>
                        <Box
                            sx={{
                                height: "auto",
                                maxWidth: "100%",
                                textAlign: "center",
                                width: {
                                    xl: 800,
                                    lg: 800,
                                    md: 400,
                                    sm: 300,
                                    xs: 300
                                },
                                fontSize: {
                                    xl: "300px",
                                    lg: "300px",
                                    md: "200px",
                                    sm: "150px",
                                    xs: "120px"
                                },
                                color: "grey.A200"
                            }}>
                            404
                        </Box>
                        <Typography
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                fontSize: {
                                    xl: "50px",
                                    lg: "50px",
                                    md: "30px",
                                    sm: "28px",
                                    xs: "20px"
                                }
                            }}
                            noWrap
                            align="center"
                            color="textPrimary"
                            variant="h1">
                            Sorry! That page can’t be found
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center"
                        }}>
                        <Button
                            color="primary"
                            component={RouterLink}
                            to="/landing"
                            variant="contained">
                            RETURN TO DASHBOARD
                        </Button>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default NotFound;
